import React, { Component } from 'react';

let numbers = [];
function NumberList() {
  var rand = Math.random().toString(10).substr(2, 4);
  var a = rand.split('').join(',');
  var array = a.split(',');
  numbers = array;
  const listItems = numbers.map((number) => (
    <div key={number.toString() + Math.random().toString(2) + Math.random().toString(2)}>{number}</div>
  ));
  return <div className="randomChars">{listItems}</div>;
}

// Captcha.
class Captcha extends Component {
  componentDidMount() {
    this.props.onRef(this);
  }
  componentWillUnmount() {
    this.props.onRef(undefined);
  }

  fetchCaptcha() {
    const concatNumbers = numbers.join('');
    return concatNumbers;
  }
  render() {
    return (
      <div className="Captcha" ref="childref">
        <NumberList />
      </div>
    );
  }

  // Should Component Update.
  shouldComponentUpdate = () => false;
}

export default Captcha;
